import React from 'react'

const Contact = () => (
  <div className="row justify-content-center">
    <div className="col-12 col-md-10 col-lg-8 col-xl-6 mb-4">
      <h1>Contact</h1>
      <p>Send me an email: <a href="mailto:&#108;&#111;&#099;&#097;&#108;&#102;&#108;&#111;&#114;&#097;&#046;&#105;&#110;&#102;&#111;&#064;&#103;&#109;&#097;&#105;&#108;&#046;&#099;&#111;&#109;" target="_blank">&#108;&#111;&#099;&#097;&#108;&#102;&#108;&#111;&#114;&#097;&#046;&#105;&#110;&#102;&#111;&#064;&#103;&#109;&#097;&#105;&#108;&#046;&#099;&#111;&#109;</a>
      </p>
      <p>Or find me on <a href="https://www.linkedin.com/in/charitygrace/" target="_blank">Linkedin</a></p>
    </div>
  </div>
);

export default Contact;
